import {
  DatePicker,
  Form,
  Row,
  Switch,
  Col,
  Divider,
  Input,
  InputNumber,
  Card,
} from 'antd';
import { FormInstance } from 'antd/lib/form';
import React from 'react';
import {
  objectParValueToString,
  shouldUpdateCompare,
} from '../../../../utils/utils2';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { LockTwoTone, UnlockTwoTone } from '@ant-design/icons';

import FormInput from 'components/FormInput';
import Value from 'components/Value';
import ThirdPartyInput from 'components/ThirdPartyInput';
import InputCurrency from 'components/InputCurrency';
import TaxSelect from 'components/TaxSelect';
import InputRate from 'components/InputRate';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue';
import Text from 'antd/lib/typography/Text';
import UtinaCard from 'components/UtinaCard';
import ParListSelect from 'components/ParListSelect';
import { toCurrency } from 'utils/utils';
import PricingListSelect from 'components/PricingListSelect';
import StatusHistoryPopover from 'components/StatusHistoryPopover';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AssetUpload from 'components/AssetUpload';

import ButtonAction from 'components/ButtonAction';
import _ from 'lodash';

export type AssetGeneralDataProps = {
  form: FormInstance;
  flagreal: boolean;
  linkedCon: boolean;
  showAsModal?: boolean;
  isCreate?: boolean;
  assettaxamount?: number;
  status?: string;
  assetphase?: string;
  fromproposal?: boolean;
  assetId?: number;
  phase?: string;
  setState: any;
  state: any;
};

const AssetGeneralData = (props: AssetGeneralDataProps) => {
  const {
    form,
    linkedCon,
    isCreate,
    assettaxamount,
    status,
    assetphase,
    fromproposal,
    assetId,
    setState,
    state,
    phase,
  } = props;
  const recalculate = (netmount: any, qty: number | any) => {
    let lnetamount =
      netmount === -1
        ? Number(form.getFieldValue('assetunitnetamount'))
        : netmount;
    let lqty = 1;

    if (qty === -1) {
      lqty = Number(form.getFieldValue('assetqty'));
    } else {
      lqty = qty;
    }

    let ltotalnetamount = lnetamount * lqty;

    let multi = form.getFieldValue('assetmulticomponents');

    let taxrate = form.getFieldValue('taxrate');
    let tax = assettaxamount ? assettaxamount : 0;

    let taxamount = 0;
    let grossamount = 0;

    if (multi === true) {
      let assetComponents = form.getFieldValue('assetComponents');
      let totaltax = _.sumBy(assetComponents, 'comptaxamount');

      taxamount = totaltax * lqty;
    } else {
      taxamount = ltotalnetamount * (taxrate / 100);
    }

    form.setFieldsValue({
      assetqtyavailable: lqty,
      assetnetamount: ltotalnetamount,
      assetfinamount: ltotalnetamount,
      assettaxamount: taxamount,
      assetgrossamount: ltotalnetamount + taxamount,
    });
  };

  const fieldName =
    phase === 'PROPOSAL' ? 'assetComponents' : 'finAssetComponents';

  const unlockAssetModel = () => {
    let unlock = state.unlockAssetModel === true ? false : true;

    setState({ unlockAssetModel: unlock });
  };
  const isDisabled = () => {
    if (
      form.getFieldValue('assetreference') === '' ||
      form.getFieldValue('assetreference') === undefined
    ) {
      return false;
    }

    return status !== 'INIT' && assetphase !== 'INIT' && !isCreate;
  };
  const convertAssetToAssetMultiComponents = (multi: boolean) => {
    if (multi) {
      let res = form
        .getFieldValue('assetComponents')
        ?.find((asset: any) => asset?.comptype === 'ASSET');

      const listCom = form.getFieldValue([fieldName]) ?? [];

      const values: any[] = [...listCom];

      if (res === undefined) {
        let newComp = {
          assetid: 0,
          compcategory: 'ASSET',
          compcategorylabel: form.getFieldValue('assetlabel'),
          compdescription: form.getFieldValue('assetlabel'),
          compdiscountamount: 0,
          compdiscountrate: 0,
          compfree1: '',
          compgrossamount: form.getFieldValue('assetgrossamount'),
          compid: Math.round(_.random(10000000)),
          compnetamount: form.getFieldValue('assetnetamount'),
          comporiginalnetamount: form.getFieldValue('assetnetamount'),
          comptaxamount: form.getFieldValue('assettaxamount'),
          comptype: 'ASSET',
          comptypelabel: 'Asset',
          flagholdback: false,
          holdbackamount: 0,
          holdbackbeleasedate: '',
          holdbackbeleasenbdays: 0,
          holdbackpercentage: 0,
          suppliername: form.getFieldValue('supplier')?.tpname,
          supplierreference: form.getFieldValue('supplier')?.tpreference,
          taxcode: form.getFieldValue('taxcode'),
          taxrate: form.getFieldValue('taxrate'),
          tpidsupplier: form.getFieldValue('supplier')?.tpid,
          asset: null as any,
          catalogidtarget: 0,
          catalogidtargetlabel: '',
          supplier: form.getFieldValue('supplier'),
        };
        values.push(newComp);
        form.setFieldValue([fieldName], values);
      }
    } else {
      form.setFieldsValue({ [fieldName]: [] });
    }
  };

  return (
    <Card
      title={
        <GetLabel
          label="generalinformation"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
    >
      <Row>
        <UtinaCard
          level={5}
          comcode="assetGeneralInformation"
          style={{ color: '#000' }}
          lg={9}
          additionalAttribute
        >
          <FormInput col md={10} name="assetreference" comcode="assetreference">
            <Value />
          </FormInput>
          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare(['statuslabel'])}
          >
            {({ getFieldValue }) => (
              <StatusHistoryPopover
                objectid={assetId ? assetId : (null as any)}
                entity="ASSET"
              >
                <FormInput name="statuslabel" col xs={10}>
                  <Text>{getFieldValue('statuslabel')}</Text>
                </FormInput>
              </StatusHistoryPopover>
            )}
          </Form.Item>
          <FormInput
            col
            md={24}
            name="assetlabel"
            comcode="assetlabel"
            rules={[{ required: true }]}
          >
            <Input />
          </FormInput>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                md={12}
                name="assetsegment"
                rules={[{ required: true }]}
                comcode="assetsegment"
              >
                <ParListSelectWithLabelInValue
                  parcode="ASSETPRD"
                  disabled={linkedCon || isDisabled()}
                  onChange={(e) => {
                    form.setFieldsValue({
                      assetsegment: e,
                      assetfamily: '',
                      assettype: '',
                      assetcategory: '',
                      assetmodel: '',
                    });
                    setState({
                      ...state,
                      assetsegment: e,
                      assetfamily: '',
                      assettype: '',
                      assetcategory: '',
                      assetmodel: '',
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>
          <Form.Item shouldUpdate={shouldUpdateCompare('assetsegment')} noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                md={12}
                name="assetfamily"
                rules={[{ required: true }]}
              >
                <ParListSelectWithLabelInValue
                  parcode="ASSETFAM"
                  parvalueparent={objectParValueToString(
                    getFieldValue('assetsegment')
                  )}
                  disabled={linkedCon || isDisabled()}
                  onChange={(e) => {
                    form.setFieldsValue({
                      assettype: '',
                      assetcategory: '',
                      assetmodel: '',
                    });
                    setState({
                      ...state,
                      assetfamily: e,
                      assettype: '',
                      assetcategory: '',
                      assetmodel: '',
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>
          <Form.Item shouldUpdate={shouldUpdateCompare('assetfamily')} noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                md={12}
                name="assettype"
                comcode="assettype"
                rules={[{ required: true }]}
              >
                <ParListSelectWithLabelInValue
                  parcode="ASSETTYPE"
                  disabled={!getFieldValue('assetfamily') || isDisabled()}
                  parvalueparent={objectParValueToString(
                    getFieldValue('assetfamily')
                  )}
                  onChange={(e) => {
                    form.setFieldsValue({
                      assettype: e,
                      assetcategory: '',
                      assetmodel: '',
                      assetlabel: e?.label,
                    });
                    setState({
                      ...state,
                      assettype: e,
                      assetcategory: '',
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>

          <Form.Item shouldUpdate={shouldUpdateCompare('assettype')} noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                md={12}
                name="assetcategory"
                comcode="assetcategory"
                rules={[{ required: true }]}
              >
                <ParListSelectWithLabelInValue
                  parcode="ASSETCAT"
                  disabled={!getFieldValue('assettype')}
                  parvalueparent={objectParValueToString(
                    getFieldValue('assettype')
                  )}
                  allowClear
                  onChange={(e) => {
                    form.setFieldsValue({
                      assetmodel: '',
                      assetlabel:
                        getFieldValue(['assettype', 'label']) +
                          ' ' +
                          e?.label ?? '',
                    });
                    setState({
                      ...state,
                      assetcategory: e,
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>

          <Form.Item
            shouldUpdate={shouldUpdateCompare('assetcategory')}
            noStyle
          >
            {({ getFieldValue }) => (
              <FormInput col md={12} name="assetmodel" comcode="assetmodel">
                <ParListSelectWithLabelInValue
                  parcode="ASSETMODEL"
                  disabled={
                    !getFieldValue('assetcategory') ||
                    ((linkedCon || isDisabled()) && !state.unlockAssetModel)
                  }
                  parvalueparent={objectParValueToString(
                    getFieldValue('assetcategory')
                  )}
                  onChange={(e) => {
                    if (e != null) {
                      form.setFieldsValue({
                        assetlabel:
                          getFieldValue('assetlabel') + ' ' + e?.label,
                      });
                    }
                    setState({
                      ...state,
                      assetmodel: e,
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>
          <FormInput col md={12} name="assetclass" comcode="assetclass">
            <ParListSelect parcode="ASSETCLASS" />
          </FormInput>
          <FormInput col md={12} comcode="unlock">
            <ButtonAction
              icon={
                state.unlockAssetModel === true ? (
                  <UnlockTwoTone twoToneColor="#52c41a" />
                ) : (
                  <LockTwoTone twoToneColor="red" />
                )
              }
              onlyIcon
              onClick={() => unlockAssetModel()}
            />
          </FormInput>

          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput col md={12} name="assetvariant" comcode="assetvariant">
                <Input />
              </FormInput>
            )}
          </Form.Item>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput col md={12} name="assetversion" comcode="assetversion">
                <Input />
              </FormInput>
            )}
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                md={12}
                name="assettaggrouping"
                comcode="assettaggrouping"
              >
                <Input />
              </FormInput>
            )}
          </Form.Item>
        </UtinaCard>
        <UtinaCard level={5} lg={6} comcode="assetPicture" additionalAttribute>
          <FormInput col xs={24} name="assetpictureurl">
            <AssetUpload
              catalogid={assetId}
              picid={1}
              name="assetpictureurl"
              form={form}
              objectreference=''
            />
          </FormInput>
        </UtinaCard>
        <UtinaCard
          level={5}
          comcode="assetFinancialInfo"
          style={{ color: '#000' }}
          lg={7}
          additionalAttribute
        >
          <FormInput
            col
            xs={24}
            md={12}
            name="currcode"
            rules={[{ required: true }]}
          >
            <ParListSelect disabled={isDisabled()} parcode="CURRENCY" />
          </FormInput>
          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare('assetmulticomponents')}
          >
            {({ getFieldValue, setFieldsValue }) => {
              return !getFieldValue('assetmulticomponents') ? (
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="taxcode"
                  rules={[{ required: true }]}
                >
                  <TaxSelect
                    taxflow="INOUT"
                    onSelected={(tax) => {
                      form.setFieldsValue({
                        taxrate: tax?.taxrate ?? 0,
                      });
                      recalculate(-1, -1);
                    }}
                  />
                </FormInput>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare([
              'currcode',
              'assetmulticomponents',
              'assetComponents',
            ])}
          >
            {({ getFieldValue }) => {
              return !getFieldValue('assetmulticomponents') ? (
                <InputCurrency
                  name="assetunitnetamount"
                  col
                  md={12}
                  onChange={(val) => recalculate(val, -1)}
                  currcode={getFieldValue('currcode')}
                  fieldname="assetunitnetamount"
                  disabled={
                    getFieldValue('assetmulticomponents') ||
                    ((linkedCon || isDisabled()) && !state.unlockAssetModel)
                  }
                />
              ) : (
                <FormInput name="assetunitnetamount" col md={12}>
                  <Text strong>
                    {toCurrency(
                      getFieldValue('assetunitnetamount'),
                      getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              );
            }}
          </Form.Item>
          <FormInput
            name="assetqty"
            comcode="assetqty"
            initialValue={1}
            col
            md={12}
          >
            <InputNumber
              defaultValue={1}
              onChange={(val) => recalculate(-1, val)}
              disabled={(linkedCon || isDisabled()) && !state.unlockAssetModel}
              min={0}
            />
          </FormInput>

          <FormInput
            name="assetqtyavailable"
            comcode="assetqtyavailable"
            col
            md={12}
          >
            <Value />
          </FormInput>

          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare([
              'currcode',
              'assetmulticomponents',
              'assetqty',
              'assetunitnetamount',
            ])}
          >
            {({ getFieldValue }) => {
              return (
                <FormInput name="assetnetamount" col md={12}>
                  <Text strong>
                    {toCurrency(
                      getFieldValue('assetnetamount'),
                      getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              );
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare([
              'currcode',
              'assetnetamount',
              'assettaxcode',
              'assettaxamount',
            ])}
          >
            {({ getFieldValue }) => {
              return (
                <FormInput col md={12} name="assettaxamount">
                  <Text strong>
                    {toCurrency(
                      getFieldValue('assettaxamount'),
                      getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              );
            }}
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare([
              'currcode',
              'assetmulticomponents',
              'assettaxamount',
              'assetgrossamount',
            ])}
          >
            {({ getFieldValue }) => {
              return (
                <FormInput col md={12} name="assetgrossamount">
                  <Text strong>
                    {toCurrency(
                      getFieldValue('assetgrossamount'),
                      getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              );
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare(['currcode'])}
            hidden={status === 'INIT'}
          >
            {({ getFieldValue }) => {
              return (
                <FormInput
                  col
                  md={12}
                  name="assetrvamount"
                  hidden={status === 'INIT'}
                >
                  <Text strong>
                    {toCurrency(
                      getFieldValue('assetrvamount'),
                      getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              );
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare(['currcode', 'assetfinamount'])}
            hidden={status === 'INIT'}
          >
            {({ getFieldValue }) => (
              <FormInput col xs={24} md={12} name="assetfinamount">
                <Text strong>
                  {toCurrency(
                    getFieldValue('assetfinamount'),
                    getFieldValue('currcode')
                  )}
                </Text>
              </FormInput>
            )}
          </Form.Item>
        </UtinaCard>
      </Row>
      <Row>
        <UtinaCard
          level={5}
          comcode="assetSupplier"
          style={{ color: '#000' }}
          lg={15}
          additionalAttribute
        >
          <FormInput col xs={24} md={12} name="assetrisklevel">
            <ParListSelect parcode="ASSETRISK" />
          </FormInput>
          <FormInput col xs={24} lg={8} name="manufacturer">
            <ThirdPartyInput role="OEM" />
          </FormInput>
          <FormInput col xs={24} md={12} name="supplier">
            <ThirdPartyInput role="SUPPLIER" display={isDisabled()} />
          </FormInput>

          <FormInput col xs={24} lg={12} xl={12} name="networkcode">
            <ParListSelect parcode="NETWORK" />
          </FormInput>
          <FormInput col xs={24} lg={12} name="tpidbroker">
            <ThirdPartyInput role="BROKER" />
          </FormInput>
          <Col md={24}>
            <Form.Item shouldUpdate={shouldUpdateCompare('flagholdback')}>
              {({ getFieldValue }) => {
                return (
                  <div>
                    {getFieldValue('flagholdback') === true && (
                      <Row gutter={32}>
                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="holdbackpercentage"
                        >
                          <InputRate
                            min={0}
                            max={100}
                            defaultValue={0}
                            onChange={(e) => {
                              form.setFieldsValue({
                                holdbackamount:
                                  (Number(e) *
                                    Number(
                                      form.getFieldValue('assetnetamount')
                                    )) /
                                  100,
                              });
                            }}
                          />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="holdbackamount"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  getFieldValue('holdbackamount') >
                                  getFieldValue('assetnetamount')
                                ) {
                                  return Promise.reject(
                                    'holdback amount is upper then asset amount.'
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <InputCurrency
                            currcode={form.getFieldValue('currcode')}
                            onChange={(e) => {
                              form.setFieldsValue({
                                holdbackpercentage:
                                  (Number(e) * 100) /
                                  Number(form.getFieldValue('assetnetamount')),
                              });
                            }}
                          />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="holdbackbeleasenbdays"
                        >
                          <InputNumber></InputNumber>
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="holdbackbeleasedate"
                        >
                          <DatePicker></DatePicker>
                        </FormInput>
                      </Row>
                    )}
                  </div>
                );
              }}
            </Form.Item>
          </Col>
          <FormInput
            col
            xs={24}
            style={{ maxWidth: '50%' }}
            md={12}
            name="flagused"
            valuePropName="checked"
          >
            <Switch
              disabled={isDisabled()}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            />
          </FormInput>
          <FormInput
            col
            xs={24}
            md={12}
            name="flagholdback"
            valuePropName="checked"
            style={{ maxWidth: '50%' }}
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            />
          </FormInput>

          <FormInput
            col
            xs={24}
            md={12}
            name="assetmulticomponents"
            valuePropName="checked"
            style={{ maxWidth: '50%' }}
          >
            <Switch
              disabled={isDisabled() && !state.unlockAssetModel}
              onChange={(e) => {
                convertAssetToAssetMultiComponents(e);
                /*form.setFieldsValue({
                  assetnetamount: 0,
                  assettaxamount: 0,
                  assetgrossamount: 0,
                  assetunitnetamount: 0,

                });*/
              }}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
            />
          </FormInput>
        </UtinaCard>

        <UtinaCard
          level={5}
          comcode="assetFormula"
          style={{ color: '#000' }}
          lg={7}
          additionalAttribute
        >
          <FormInput col xs={24} lg={24} name="degfeesformula">
            <PricingListSelect
              style={{ width: '100%' }}
              params={{
                offerid: 0,
                ctecategory: '',
                ctetype: 'DEGFEES',
                filters: '',
                finamount: 0,
              }}
            />
          </FormInput>
          <FormInput col xs={24} lg={24} name="spfeesformula">
            <PricingListSelect
              style={{ width: '100%' }}
              params={{
                offerid: 0,
                ctecategory: '',
                ctetype: 'SPFEES',
                filters: '',
                finamount: 0,
              }}
            />
          </FormInput>
          <FormInput col xs={24} lg={24} name="tpofformula">
            <PricingListSelect
              style={{ width: '100%' }}
              params={{
                offerid: 0,
                ctecategory: '',
                ctetype: 'PPOF',
                filters: '',
                finamount: 0,
              }}
            />
          </FormInput>
        </UtinaCard>

        {/* <Col span={8} style={{ fontWeight: 'bold', background: '#F6F3F2' }}>
              <Card type="inner" style={{ background: '#F6F3F2' }}>
                <Row gutter={32}>
                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="currcode"
                    rules={[{ required: true }]}
                  >
                    <ParListSelect parcode="CURRENCY" />
                  </FormInput>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare('assetmulticomponents')}
                  >
                    {({ getFieldValue, setFieldsValue }) => {
                      return !getFieldValue('assetmulticomponents') ? (
                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="taxcode"
                          rules={[{ required: true }]}
                        >
                          <TaxSelect
                            taxflow="INOUT"
                            onSelected={(tax) => {
                              form.setFieldsValue({ taxrate: tax.taxrate });
                              recalculate(-1, -1);
                            }}
                            disabled={linkedCon}
                          />
                        </FormInput>
                      ) : (
                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="taxcode"
                          rules={[{ required: false }]}
                        >
                          <>
                            {setFieldsValue({ assettaxcode: '' })}
                            <TaxSelect
                              taxflow="INOUT"
                              onSelected={(tax) => {
                                form.setFieldsValue({ taxrate: tax.taxrate });
                                recalculate(-1, -1);
                              }}
                              disabled
                              value=""
                            />
                          </>
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'currcode',
                      'assetmulticomponents',
                    ])}
                  >
                    {({ getFieldValue }) => {
                      return !getFieldValue('assetmulticomponents') ? (
                        <InputCurrency
                          col
                          md={12}
                          onChange={(val) => recalculate(val, -1)}
                          currcode={getFieldValue('currcode')}
                          rules={[
                            { required: !getFieldValue('assetmulticomponents') },
                          ]}
                          fieldname="assetunitnetamount"
                          disabled={
                            getFieldValue('assetmulticomponents') || linkedCon
                          }
                        />
                      ) : (
                        <FormInput name="assetunitnetamount" col md={12}>
                          <Text strong>
                            {toCurrency(
                              getFieldValue('assetunitnetamount'),
                              getFieldValue('currcode')
                            )}
                          </Text>
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                  <FormInput name="assetqty" comcode="assetqty" col md={12}>
                    <InputNumber
                      defaultValue={1}
                      onChange={(val) => recalculate(-1, val)}
                      disabled={linkedCon}
                    />
                  </FormInput>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare(['assetqty'])}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <FormInput
                          name="assetqtyavailable"
                          comcode="assetqtyavailable"
                          col
                          md={12}
                        >
                          <Value />
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'currcode',
                      'assetmulticomponents',
                      'assetqty',
                      'assetunitnetamount',
                    ])}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <FormInput name="assetnetamount" col md={12}>
                          <Text strong>
                            {toCurrency(
                              getFieldValue('assetnetamount'),
                              getFieldValue('currcode')
                            )}
                          </Text>
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'currcode',
                      'assetnetamount',
                      'assettaxcode',
                    ])}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <FormInput col md={12} name="assettaxamount">
                          <Text strong>
                            {toCurrency(
                              getFieldValue('assettaxamount'),
                              getFieldValue('currcode')
                            )}
                          </Text>
                        </FormInput>
                      );
                    }}
                  </Form.Item>

                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare([
                      'currcode',
                      'assetmulticomponents',
                      'assettaxamount',
                    ])}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <FormInput col md={12} name="assetgrossamount">
                          <Text strong>
                            {toCurrency(
                              getFieldValue('assetgrossamount'),
                              getFieldValue('currcode')
                            )}
                          </Text>
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={shouldUpdateCompare(['currcode'])}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <FormInput col md={12} name="assetrvamount">
                          <Text strong>
                            {toCurrency(
                              getFieldValue('assetrvamount'),
                              getFieldValue('currcode')
                            )}
                          </Text>
                        </FormInput>
                      );
                    }}
                  </Form.Item>
                </Row>
              </Card>
            </Col> */}
        <Divider />
      </Row>

      {!isCreate && (
        <>
          <Divider />

          <Row gutter={32}>
            <FormInput col xs={24} md={6} name="assetorderreference">
              <Input disabled={isDisabled()} />
            </FormInput>
            <FormInput col xs={24} md={4} name="assetorderdate">
              <DatePicker disabled={isDisabled()} />
            </FormInput>
            <FormInput col xs={24} md={4} name="assetexpdeliverydate">
              <DatePicker />
            </FormInput>
            <FormInput col xs={24} md={6} name="assetdeliveryreference">
              <Input disabled={isDisabled()} />
            </FormInput>
            <FormInput col xs={24} md={4} name="assetdeliverydate">
              <DatePicker disabled={isDisabled()} />
            </FormInput>
          </Row>
        </>
      )}
    </Card>
  );
};

export default AssetGeneralData;
